import React from 'react';
import ReactDOM from 'react-dom';
import Pages from './pages/index';
import "antd/dist/antd.css";
import './styles/index.css';
class App extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
    };
  }

  render() {
    return <Pages />;
  }
}

ReactDOM.render(<App />, document.getElementById('root'));